interface UserTags {
  [key: string]: string | number | boolean;
}

export class OneSignalAdapter {
  private _userExternalId: string | null = null;
  private _appId: string | null = null;
  private _eventAnchor: HTMLDivElement | null = null;

  constructor(
    eventAnchor: HTMLDivElement | null,
    appId: string,
    userExternalId: string,
  ) {
    this._eventAnchor = eventAnchor;
    this._appId = appId;
    this._userExternalId = userExternalId;

    this.initOneSignal().catch((e) => {
      console.error("Error iniciando OneSignal.");
      console.error(e);
    });
  }

  addTags(tags: UserTags): void {
    window.OneSignal.User.addTags(tags);
  }

  getTags(): UserTags {
    return window.OneSignal.User.getTags();
  }

  isUserSubscribed(): boolean {
    return !(typeof window.OneSignal.User.PushSubscription.id === "undefined");
  }

  pushSubscriptionOptedIn(): boolean {
    return window.OneSignal.User.PushSubscription.optedIn;
  }

  requestPermission(): void {
    window.OneSignal.Notifications.requestPermission();
  }

  private async initOneSignal(): Promise<void> {
    if (!window.OneSignal) {
      await this.loadOneSignalSDK();
    }

    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async (OneSignal) => {
      await OneSignal.init({
        appId: this._appId,
      });

      OneSignal.login(this._userExternalId);
      this.listenPermissionChange();

      console.log("Adaptador push notifications: OneSignal.");
      this._eventAnchor!.dispatchEvent(
        new CustomEvent("onPushNotificationsAdapterInitiated"),
      );
    });
  }

  private async loadOneSignalSDK(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src =
        "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
      script.async = true;
      document.head.appendChild(script);
      script.onload = () => resolve();
      script.onerror = reject;
    });
  }

  private listenPermissionChange(): void {
    window.OneSignal.Notifications.addEventListener(
      "permissionChange",
      (permission: boolean) => {
        this._eventAnchor!.dispatchEvent(
          new CustomEvent("onPushNotificationsPermissionsChanged", {
            detail: permission,
          }),
        );
      },
    );
  }
}
